module.exports = __webpack_public_path__ + "static/img/gzhome.10b6fecd.jpg";